import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ClientesEntity, EmpresaInfo } from './session-return-jwt.model';

@Injectable({
  providedIn: 'root'
})
export class ModalStateService {
  private modalVisibilitySubject = new BehaviorSubject<boolean>(false);
  public modalVisibility$ = this.modalVisibilitySubject.asObservable();

  private modalDataSubject = new BehaviorSubject<ClientesEntity[] | null>(null);
  public modalData$ = this.modalDataSubject.asObservable();

  private allowLoadSubject = new BehaviorSubject<boolean>(false);
  public allowLoad$ = this.allowLoadSubject.asObservable();


  private shouldEvaluateRuleSubject = new BehaviorSubject<boolean>(true);
  public shouldEvaluateRule$ = this.shouldEvaluateRuleSubject.asObservable();
  private ruleAlreadyEvaluated = false;

  private empresasSubject = new BehaviorSubject<EmpresaInfo[] | null>(null);
  public empresas$ = this.empresasSubject.asObservable();

  private showEmpresaPadraoSubject = new BehaviorSubject<boolean>(false);
  showEmpresaPadrao$ = this.showEmpresaPadraoSubject.asObservable();

  setShowEmpresaPadrao(value: boolean) {
    this.showEmpresaPadraoSubject.next(value);
  }

  setEmpresas(empresas: EmpresaInfo[]) {
    this.empresasSubject.next(empresas);
  }

  getEmpresas(): EmpresaInfo[] | null {
    return this.empresasSubject.getValue();
  }


  enableRuleEvaluationOnce(): void {
    if (!this.ruleAlreadyEvaluated) {
      this.shouldEvaluateRuleSubject.next(true);
      this.ruleAlreadyEvaluated = true;
    } else {
      this.shouldEvaluateRuleSubject.next(false);
    }
  }

  // Permite definir manualmente se a regra deve ser avaliada
  setShouldEvaluateRule(value: boolean) {
    this.shouldEvaluateRuleSubject.next(value);
  }

  // Método usado no componente para saber se deve executar a lógica
  showPopover(): boolean {
    return this.shouldEvaluateRuleSubject.getValue();
  }

  // Permite controlar se o modal deve ser carregado/renderizado
  setAllowLoad(value: boolean) {
    this.allowLoadSubject.next(value);
  }

  get shouldLoad(): boolean {
    return this.allowLoadSubject.getValue();
  }

  openModal(data: ClientesEntity[]) {
    document.body.style.overflow = 'hidden';
    this.modalDataSubject.next(data);
    this.modalVisibilitySubject.next(true);
  }

  closeModal() {
    this.modalVisibilitySubject.next(false);
    this.modalDataSubject.next(null);
  }

  get isOpen(): boolean {
    return this.modalVisibilitySubject.getValue();
  }
}
